import { fmtDate } from "@/lib/api";

const TEN_MIN = 10 * 60 * 1000;

export const stripeState = (o) => {
  if (o.payment_status === "paid") {
    if (o.webhook_received_at) return ["Confirmé par webhook", "bg-emerald-100 text-emerald-800", "webhook"];
    const late = o.paid_at && Date.now() - new Date(o.paid_at).getTime() > TEN_MIN;
    return [late ? "Vérification directe — webhook non reçu" : "Confirmé par vérification directe", "bg-orange-100 text-orange-800", "direct"];
  }
  if (["expired", "failed"].includes(o.stripe_state)) return [o.stripe_state === "expired" ? "Expiré" : "Échec", "bg-red-100 text-red-800", o.stripe_state];
  return ["En attente", "bg-slate-100 text-slate-600", "pending"];
};

export const StripeBadge = ({ order, testId }) => {
  const [label, cls, key] = stripeState(order);
  return <span data-testid={testId} data-state={key} className={`inline-flex px-2 py-0.5 rounded-full text-[11px] font-semibold ${cls}`}>{label}</span>;
};

export const StripeTimeline = ({ events }) => (
  <ul data-testid="order-stripe-timeline" className="mt-2 flex flex-col gap-1.5 text-xs">
    {events.length === 0 && <li className="text-slate-500">Aucun événement Stripe reçu.</li>}
    {events.map((e, i) => (
      <li key={e.id || i} data-testid={`order-stripe-event-${i}`} className="flex flex-wrap items-center gap-2 text-slate-700">
        <span className={`w-2 h-2 rounded-full ${e.source === "webhook" ? "bg-emerald-500" : "bg-orange-500"}`} />
        <span className="text-slate-400">{fmtDate(e.at)}</span>
        <span className="font-medium">{e.type}</span>
        {e.source === "webhook" && <span className="text-slate-400 font-mono">{e.id} · signature valide</span>}
      </li>
    ))}
  </ul>
);
